var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoUserGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user_3_",
    "data-name": "user (3)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.621,
    height: 33.173,
    viewBox: "0 0 30.621 33.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M33.266,28.522a9.983,9.983,0,0,0,4.551-8.166C37.816,15.933,34.2,11,29.311,11S20.8,15.933,20.8,20.356a9.983,9.983,0,0,0,4.551,8.166A15.336,15.336,0,0,0,14,43.322a.853.853,0,0,0,.851.851h28.92a.853.853,0,0,0,.851-.851A15.336,15.336,0,0,0,33.266,28.522Zm-10.76-8.166c0-4.381,3.615-7.655,6.8-7.655s6.8,3.275,6.8,7.655-3.615,7.655-6.8,7.655S22.506,24.737,22.506,20.356ZM15.744,42.472a13.592,13.592,0,0,1,27.134,0Z",
    transform: "translate(-14 -11)",
    fill: "#006664"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUserGreen);
export default __webpack_public_path__ + "static/media/logo-user-green.9885d3e0867d9f7d25f57982d662feef.svg";
export { ForwardRef as ReactComponent };